import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _PickerItemGetter = Getter.of();
export const _PickerItemResponseGetter = Getter.of();
export const _PickerItemsGetter = Getter.of();
export const _PickerItemsResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _PickerItemsResponse2PickerItems = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _PickerItemResponse2PickerItem = _Response2ResponseData();
export const _PickerItem2Attributes = Fold.compose(_PickerItemGetter, Res._Response(), Lens.prop("attributes"));
export const _PickerItemAttributes2BaseApiUrl = Fold.compose(_PickerItem2Attributes, Lens.prop("baseApiUrl"));
export const _PickerItemAttributes2Realm = Fold.compose(_PickerItem2Attributes, Lens.prop("realm"));
export const _PickerItemAttributes2MainTerritoryCode = Fold.compose(_PickerItem2Attributes, Lens.prop("mainTerritoryCode"));

